// Global JavaScript for Watch Shop Theme

// Cart functionality
class CartManager {
  constructor() {
    this.cartCountElement = document.querySelector('[data-cart-count]');
    this.updateCartCount();
    this.bindEvents();
  }

  bindEvents() {
    // Update cart count when items are added
    document.addEventListener('cart:updated', () => {
      this.updateCartCount();
    });
  }

  async updateCartCount() {
    try {
      const response = await fetch(window.routes.cart_url + '.js');
      const cart = await response.json();
      if (this.cartCountElement) {
        this.cartCountElement.textContent = cart.item_count;
      }
    } catch (error) {
      console.error('Error updating cart count:', error);
    }
  }
}

// Product form submission
document.addEventListener('DOMContentLoaded', () => {
  const productForms = document.querySelectorAll('.product-card__form, form[action*="cart"]');
  
  productForms.forEach(form => {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      
      const formData = new FormData(form);
      const submitButton = form.querySelector('button[type="submit"]');
      const originalText = submitButton.textContent;

      // Disable button and show loading state
      submitButton.disabled = true;
      submitButton.textContent = 'Adding...';

      try {
        const response = await fetch(window.routes.cart_add_url, {
          method: 'POST',
          body: formData
        });

        if (response.ok) {
          const data = await response.json();
          submitButton.textContent = 'Added!';
          
          // Dispatch custom event for cart update
          document.dispatchEvent(new CustomEvent('cart:updated'));
          
          // Show success message (you can customize this)
          if (window.cartStrings && window.cartStrings.added) {
            // Add your notification system here
            console.log('Product added to cart');
          }

          // Reset button after 2 seconds
          setTimeout(() => {
            submitButton.disabled = false;
            submitButton.textContent = originalText;
          }, 2000);
        } else {
          throw new Error('Failed to add product to cart');
        }
      } catch (error) {
        console.error('Error adding to cart:', error);
        submitButton.disabled = false;
        submitButton.textContent = originalText;
        alert('Failed to add product to cart. Please try again.');
      }
    });
  });

  // Initialize cart manager
  new CartManager();
});

// Smooth scroll for anchor links
document.querySelectorAll('a[href^="#"]').forEach(anchor => {
  anchor.addEventListener('click', function (e) {
    e.preventDefault();
    const target = document.querySelector(this.getAttribute('href'));
    if (target) {
      target.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  });
});

// Mobile menu toggle (if needed)
class MobileMenu {
  constructor() {
    this.menuButton = document.querySelector('.mobile-menu-button');
    this.menu = document.querySelector('.header__nav');
    
    if (this.menuButton && this.menu) {
      this.menuButton.addEventListener('click', () => {
        this.menu.classList.toggle('active');
        this.menuButton.classList.toggle('active');
      });
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new MobileMenu();
});

// Lazy loading images
if ('IntersectionObserver' in window) {
  const imageObserver = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const img = entry.target;
        if (img.dataset.src) {
          img.src = img.dataset.src;
          img.removeAttribute('data-src');
          observer.unobserve(img);
        }
      }
    });
  });

  document.querySelectorAll('img[data-src]').forEach(img => {
    imageObserver.observe(img);
  });
}

